import { toast } from "react-hot-toast";
import { apiConnector } from "../apiConnector";
import { messageendpoints } from "../apis";

const { ADD_MESSAGE_API, GET_MESSAGES_BY_CONVERSATION_ID_API } =
  messageendpoints;

// 1. Get Messages by Conversation ID
export function getMessagesByConversationId(conversationId) {
  return async () => {
    const toastId = toast.loading("Loading messages...");
    const token = JSON.parse(localStorage.getItem("token"));

    try {
      const response = await apiConnector(
        "GET",
        `${GET_MESSAGES_BY_CONVERSATION_ID_API}/${conversationId}`,
        null,
        {
          Authorization: `Bearer ${token}`,
        }
      );

      if (!response.data?.success) throw new Error(response.data.message);

      // toast.success("Messages loaded");
      return response.data.messages;
    } catch (error) {
      console.error("GET MESSAGES ERROR:", error);
      toast.error("Failed to load messages");
      return [];
    } finally {
      toast.dismiss(toastId);
    }
  };
}

// 2. Add Message to Conversation
export function addMessage(
  conversationId,
  sender,
  content,
  imageUrl,
  webLinks,
  youtubeLinks
) {
  // console.log("api addmess",ADD_MESSAGE_API)
  // console.log("api data",conversationId)
  // console.log("api data",sender)
  // console.log("api data",content)
  return async () => {
    // const toastId = toast.loading("Sending message...");
    const token = JSON.parse(localStorage.getItem("token"));

    try {
      const response = await apiConnector(
        "POST",
        `${ADD_MESSAGE_API}/${conversationId}`,
        { sender, content, imageUrl, webLinks, youtubeLinks },
        {
          Authorization: `Bearer ${token}`,
        }
      );

      if (!response.data) {
        //  console.log("ADD MESSAGE ERROR")
      }

      if (!response.data) throw new Error("Message not created");

      //toast.success("Message sent");
      return response.data; // Full populated conversation
    } catch (error) {
      //console.error("SEND MESSAGE ERROR:", error);
      // toast.error("Failed to send message");
      return null;
    } finally {
      //  toast.dismiss(toastId);
    }
  };
}
